import React from "react";

export function ThinField({ label, children, className = "" }) {
    return (
        <div className={`min-w-0 ${className}`}>
            {label && (
                <label className="mb-0.5 block text-[11px] font-semibold text-gray-500">
                    {label}
                </label>
            )}
            {children}
        </div>
    );
}

export function ThinInput({ className = "", ...props }) {
    return (
        <input
            {...props}
            className={`h-8 w-full rounded-md border border-gray-200 bg-white px-2 text-xs text-gray-800 outline-none transition focus:border-green-500 disabled:bg-gray-100 disabled:text-gray-400 ${className}`}
        />
    );
}

export function ThinSelect({ className = "", children, ...props }) {
    return (
        <select
            {...props}
            className={`h-8 w-full rounded-md border border-gray-200 bg-white px-2 text-xs text-gray-800 outline-none transition focus:border-green-500 disabled:bg-gray-100 disabled:text-gray-400 ${className}`}
        >
            {children}
        </select>
    );
}

export function ThinTextarea({ className = "", ...props }) {
    return (
        <textarea
            {...props}
            className={`min-h-[58px] w-full resize-none rounded-md border border-gray-200 bg-white px-2 py-1.5 text-xs text-gray-800 outline-none transition focus:border-green-500 disabled:bg-gray-100 disabled:text-gray-400 ${className}`}
        />
    );
}

export function ThinButton({
    children,
    onClick,
    disabled = false,
    variant = "default",
    type = "button",
    className = "",
}) {
    const variantClass =
        variant === "primary"
            ? "bg-green-600 text-white hover:bg-green-700"
            : variant === "blue"
                ? "border border-blue-500 bg-white text-blue-600 hover:bg-blue-50"
                : variant === "danger"
                    ? "border border-red-200 bg-white text-red-600 hover:bg-red-50"
                    : "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50";

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            className={`h-8 rounded-md px-3 text-xs font-semibold transition disabled:cursor-not-allowed disabled:opacity-60 ${variantClass} ${className}`}
        >
            {children}
        </button>
    );
}

export function MiniInfoPill({ children, tone = "default", className = "" }) {
    const toneClass =
        tone === "success"
            ? "border-green-200 bg-green-50 text-green-700"
            : tone === "danger"
                ? "border-red-200 bg-red-50 text-red-700"
                : tone === "blue"
                    ? "border-blue-200 bg-blue-50 text-blue-700"
                    : "border-gray-200 bg-white text-gray-500";

    return (
        <span
            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${toneClass} ${className}`}
        >
            {children}
        </span>
    );
}